





























import { Vue, Component, Prop } from "vue-property-decorator";

@Component({
  components: {
    Slick: () => import("vue-slick")
  }
})
export default class ProfileMenu extends Vue {
  @Prop(String) optionActive!: string;
  windowWidth = 0;
  options = [
    {
      title: (this as any).$root.config.MyProfile.Menu.myProfile,
      img: require("@/./assets/icons/profile-icon.svg"),
      id: "option1",
      link: "/perfil"
    },
    {
      title: (this as any).$root.config.MyProfile.Menu.savedOffers,
      img: require("@/./assets/icons/save-icon.svg"),
      id: "option3",
      link: "/ofertas-guardadas"
    },
    {
      title: (this as any).$root.config.MyProfile.Menu.myOffers,
      img: require("@/./assets/icons/postulation-icon.svg"),
      id: "option2",
      link: "/postulaciones"
    }
    /*{
      title: "Mis Asignaciones",
      img: require("@/./assets/icons/asignaciones.svg"),
      id: "option5",
      link: "/asignaciones"
    },
    {
      title: "Mensajes",
      img: require("@/./assets/icons/message-icon.svg"),
      id: "option4",
      link: "/mensajes"
    }*/
  ];

  currSlide = 1;

  slickOptions = {
    infinite: false,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: "100px",
    initialSlide: this.currSlide,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 499,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  };

  created() {
    window.addEventListener("resize", (this as any).$root.handleResize);
    (this as any).$root.handleResize();
  }

  destroyed() {
    window.removeEventListener("resize", (this as any).$root.handleResize);
  }

  beforeUpdate() {
    // if (this.$refs.slick) {
    //   (this as any).$refs.slick.destroy();
    // }
  }

  updated() {
    // this.$nextTick(function() {
    //   if (this.$refs.slick) {
    //     (this as any).$refs.slick.create();
    //   }
    // });
  }
}
